import {
  IonAlert,
  IonBadge,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonDatetime,
  IonDatetimeButton,
  IonFooter,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonLabel,
  IonModal,
  IonRow,
  IonSegment,
  IonSegmentButton,
  IonSelect,
  IonSelectOption,
  IonText,
  IonTitle,
  IonToggle,
  IonToolbar,
} from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import moment from "moment";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { debounce, isEmpty } from "underscore";
import { v4 as uuidv4 } from "uuid";
import { OrderStatus } from "./Constants";
import {
  CapacitorPreferencesConstants,
  MetricConstants,
  MetricTypeConstants,
} from "../../../components/Constants";
import config from "../../../components/helpers/socket/config";
import { pubsubEvents } from "../../../components/helpers/socket/pubsubEvent";
import {
  removeCapacitorPreference,
  setCapacitorPreference,
} from "../../../utils/core-utils/capPreferencesUtils";
import {
  hapticsImpactHeavy,
  hapticsImpactMedium,
} from "../../../utils/core-utils/hapticUtils";
import firebaseEventConfig from "../../../utils/firebaseAnalytics/firebaseEventConfig";
import { CMEDfirebaseLogEvent } from "../../../utils/firebaseAnalytics/firebaseUtils";
import { startMetric } from "../../../utils/metric-utils/metricUtils";
import { send } from "../../../utils/sockets/asyncSocket";
import { DecimalToFractionalConverter } from "../common/utils/DecimalToFractionalConverterAndValidator";
import {
  FractionalToDecimalConverter,
  validatePrice,
} from "../common/utils/FractionalToDecimalConverterAndValidator";
import { parseTickGroupString } from "../common/utils/parseTickGroupString";
import { PriceErrorConstants } from "../common/utils/PriceErrorConstants";
import { QuantityErrorConstants } from "../common/utils/QuantityErrorConstants";
import {
  formatPriceForScreen,
  removeCommasOnFocus,
} from "../common/utils/priceInputUtils";
import { PriceRegexValidator } from "../common/utils/PriceRegexValidator";
import { CMEDPermissions } from "../MarketData/MarketDataContent";
import TickComponent from "../MarketData/TickComponent";
import optionsGridConfig from "../OptionsGrid/optionsGridConfig";
import EmptyTickComponent from "../common/components/EmptyTickComponent";
import EmptyDateComponent from "../common/components/EmptyDateComponent";
import expandIcon from "../../../theme/custom-icons/expand_more.svg";
import Skeleton_OrderViewModal from "./Skeleton__OrderViewModal";
import { getModifiedContractNameFromOrder } from "../../../utils/commonUtils";
import { OrdersDataType, OrdersType } from "../../../Constants";

/**
 * @author
 * E45597 Aryamitra Chaudhuri
 * E47440 Vithal Agrawal
 */

const QUANTITY_LIMITS = {
  MIN: 1,
  MAX: 99999,
};

type OrderViewModalProps = {
  orderId: any;
  setOrderId: any;
  openOrderViewModal: any;
  closeOrderViewModal: any;
  setOpenOrderViewModal: any;
  orderLoading: any;
  setOrderLoading: any;
  marketDataLoading: any;
  setMarketDataLoading: any;
  fillsDataLoading: any;
  setFillsDataLoading: any;
  userCMEDEntitlements: CMEDPermissions | undefined;
};

const OrderViewModal: React.FC<OrderViewModalProps> = ({
  orderId,
  setOrderId,
  openOrderViewModal,
  closeOrderViewModal,
  setOpenOrderViewModal,
  orderLoading,
  setOrderLoading,
  marketDataLoading,
  setMarketDataLoading,
  fillsDataLoading,
  setFillsDataLoading,
  userCMEDEntitlements,
}) => {
  const refDate = "0001-01-01T00:00:00";
  const [tifs, setTifs] = useState<any[]>([
    {
      id: "1",
      desc: "Good for day",
      code: "GFD",
    },
    {
      id: "2",
      desc: "Good till cancelled",
      code: "GTC",
    },
    {
      id: "4",
      desc: "Good till date",
      code: "GTD",
    },
  ]);
  const [currentSegment, setCurrentSegment] = useState<string>("orderTicket");
  const [tradingOrderDetailsData, setTradingOrderDetailsData] = useState<any[]>(
    [],
  );
  const [isAutomatedOrder, setIsAutomatedOrder] = useState<boolean>(false);
  const [tradingOrderFillsData, setTradingOrderFillsData] = useState<{
    data: any[];
    identifier: string;
  }>({ data: [], identifier: "" });
  const [tradingOrderBidOffersData, setTradingOrderBidOffersData] = useState<{
    data: any[];
    identifier: string;
  }>({ data: [], identifier: "" });
  const [isHoldOrderAlertOpen, setIsHoldOrderAlertOpen] =
    useState<boolean>(false);
  const [isKillOrderAlertOpen, setIsKillOrderAlertOpen] =
    useState<boolean>(false);
  const [isActivateOrderAlertOpen, setIsActivateOrderAlertOpen] =
    useState<boolean>(false);
  const [isViewContractNameAlertOpen, setIsViewContractNameAlertOpen] =
    useState<boolean>(false);
  const [selectedTif, setselectedTif] = useState<string>("");
  const [isModifyOrderAlertOpen, setIsModifyOrderAlertOpen] =
    useState<boolean>(false);
  const [isOrderModified, setIsOrderModified] = useState<boolean>(false);

  const [side, setSide] = useState<any>(
    tradingOrderDetailsData[0]?.b.toLocaleLowerCase() === "buy"
      ? "bid"
      : "offer",
  );
  const [ticks, setTicks] = useState<any>({ up: [], down: [] });
  const [stoppriceticks, setstoppriceTicks] = useState<any>({
    up: [],
    down: [],
  });
  const [priceValue, setpriceValue] = useState(
    tradingOrderDetailsData[0]?.p2?.f,
  );
  const [priceValueRaw, setpriceValueRaw] = useState(
    tradingOrderDetailsData[0]?.p2?.r,
  );
  const [stoppriceValueRaw, setstoppriceValueRaw] = useState(
    tradingOrderDetailsData[0]?.sp?.r,
  );
  const [stoppriceValue, setstoppriceValue] = useState(
    tradingOrderDetailsData[0]?.sp?.f,
  );
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  const [errorMsg, seterrorMsg] = useState<string>();
  const [tickStrategy, settickStrategy] = useState(undefined);
  const [tickGroupValidation, settickGroupValidation] = useState({
    max: 0,
    min: 0,
  });
  const [tickCounter, settickCounter] = useState(-1);
  const [stoptickCounter, setstoptickCounter] = useState(-1);
  const [basePriceValue, setbasePriceValue] = useState(
    tradingOrderDetailsData[0]?.p2?.f,
  );
  const [basePriceValueRaw, setbasePriceValueRaw] = useState(
    tradingOrderDetailsData[0]?.p2?.r,
  );
  const [basestopPriceValue, setbasestopPriceValue] = useState(
    tradingOrderDetailsData[0]?.sp?.f,
  );
  const [basestopPriceValueRaw, setbasestopPriceValueRaw] = useState(
    tradingOrderDetailsData[0]?.sp?.r,
  );
  const [quantity, setquantity] = useState(QUANTITY_LIMITS.MIN);
  const [disclosedQuantity, setDisclosedQuantity] = useState(0);
  const [stopPriceErrorMsg, setstopPriceErrorMsg] = useState<string>();
  const [stopPriceErrorMsgFlag, setstopPriceErrorMsgFlag] =
    useState<boolean>(false);
  const [priceMinMaxErrorFlag, setPriceMinMaxErrorFlag] =
    useState<boolean>(false);
  const [stopPriceMinMaxErrorFlag, setStopPriceMinMaxErrorFlag] =
    useState<boolean>(false);
  const [stopPriceValidationErrorMsg, setstopPriceValidationErrorMsg] =
    useState<string>();
  const [stopPriceValidationErrorMsgFlag, setstopValidationPriceErrorMsgFlag] =
    useState<boolean>(false);
  const [expiryDate, setexpiryDate] = useState<any>(
    tradingOrderDetailsData[0]?.e > refDate
      ? tradingOrderDetailsData[0]?.e
      : new Date().toISOString(),
  );
  const [expiryDateAPIFormatted, setExpiryDateAPIFormatted] = useState<any>(
    formatDate(
      tradingOrderDetailsData[0]?.e > refDate
        ? tradingOrderDetailsData[0]?.e
        : new Date().toISOString(),
      "API",
    ),
  );
  const [priceValueLoadingErrorState, setPriceValueLoadingErrorState] =
    useState<any>({
      isLoading: true,
      error: false,
    });
  const [priceType, setpriceType] = useState<any>();
  const [notes, setNotes] = useState(tradingOrderDetailsData[0]?.on);
  const [notesErrorFlag, setNotesErrorFlag] = useState(false);
  const [contractName, setContractName] = useState<string>("");
  const [contractLoading, setContractLoading] = useState<boolean>(true);
  const [tickGroup, settickGroup] = useState<string | undefined>(undefined);
  const [quantityErrorFlag, setQuantityErrorFlag] = useState<boolean>(false);
  const [quantityErrorMsg, setQuantityErrorMsg] = useState<string>("");
  const [disclosedQuantityErrorFlag, setDisclosedQuantityErrorFlag] =
    useState<boolean>(false);
  const [disclosedQuantityErrorMsg, setDisclosedQuantityErrorMsg] =
    useState<string>("");
  const today = new Date(new Date().setDate(new Date().getDate()));

  const validateDisclosedQuantity = (disclosedQty: number, mainQty: number) => {
    if (disclosedQty > mainQty && disclosedQty > QUANTITY_LIMITS.MAX) {
      setDisclosedQuantityErrorFlag(true);
      setDisclosedQuantityErrorMsg(
        QuantityErrorConstants.INVALID_DISPLAY_QUANTITY_ERROR,
      );
    } else if (
      disclosedQty < QUANTITY_LIMITS.MIN ||
      disclosedQty > QUANTITY_LIMITS.MAX
    ) {
      setDisclosedQuantityErrorFlag(true);
      setDisclosedQuantityErrorMsg(
        QuantityErrorConstants.ZERO_DISPLAY_QUANTITY_ERROR,
      );
    } else if (disclosedQty > mainQty) {
      setDisclosedQuantityErrorFlag(true);
      setDisclosedQuantityErrorMsg(
        QuantityErrorConstants.INVALID_DISPLAY_QUANTITY_ERROR,
      );
    } else {
      setDisclosedQuantityErrorFlag(false);
      setDisclosedQuantityErrorMsg("");
    }
  };

  const stopPriceRequestIds = useRef<any[]>([]);
  const priceRequestIds = useRef<any[]>([]);

  const allFutureDates = new Date(
    new Date().getFullYear() + 99,
    new Date().getMonth(),
    new Date().getDate(),
  );

  const tableHeaders1 = ["QTY", "BID", "OFFER", "QTY"];
  const tableHeaders2 = ["FILL TIME", "QTY", "PRICE"];

  useEffect(() => {
    if (tradingOrderDetailsData.length > 0 && !isOrderModified)
      setselectedTif(
        getIdByDesc(tradingOrderDetailsData[0]?.ti?.split("-")[1]?.trim()),
      );
  }, [tradingOrderDetailsData, isOrderModified]);

  useEffect(() => {
    if (
      tradingOrderDetailsData[0]?.t === "Stop-Limit" ||
      tradingOrderDetailsData[0]?.t === "Stop with Protection"
    )
      !stopPriceErrorMsgFlag &&
        _stopPriceValidation(stoppriceValueRaw, priceValueRaw);
  }, [stoppriceValue, priceValue]);

  function _stopPriceValidation(stopPriceRaw: any, orderPriceRaw: any) {
    setstopPriceValidationErrorMsg("");
    setstopValidationPriceErrorMsgFlag(false);

    if (tradingOrderDetailsData[0]?.t === "Stop-Limit") {
      if (side === "bid" && stopPriceRaw > orderPriceRaw) {
        setstopValidationPriceErrorMsgFlag(true);
        setstopPriceValidationErrorMsg(
          "Bid price cannot be lower than stop price",
        );
      } else if (side === "offer" && orderPriceRaw > stopPriceRaw) {
        setstopPriceValidationErrorMsg(
          "Offer price cannot be higher than stop price",
        );
        setstopValidationPriceErrorMsgFlag(true);
      }
    }
  }

  /**
   * Concatenates the new direction ticks to the current direction list
   *
   * @param  {Object} response Updated list of UP or DOWN tick prices
   * @return {undefined}
   */
  function updateTicks(response: any) {
    const pricesResponse = response.payload;
    if (pricesResponse.up !== undefined && pricesResponse.down !== undefined) {
      setTicks(pricesResponse);
    } else if (
      pricesResponse.up !== undefined ||
      pricesResponse.down !== undefined
    ) {
      pricesResponse.up !== undefined
        ? updateUporDownTick("up", pricesResponse.up)
        : updateUporDownTick("down", pricesResponse.down);
    }
  }

  /**
   * Concatenates the new direction ticks to the current direction list for stop price
   *
   * @param  {Object} response Updated list of UP or DOWN tick prices
   * @return {undefined}
   */
  function updatestoppriceTicks(response: any) {
    const pricesResponse = response.payload;
    if (pricesResponse.up !== undefined && pricesResponse.down !== undefined) {
      setstoppriceTicks(pricesResponse);
    } else if (
      pricesResponse.up !== undefined ||
      pricesResponse.down !== undefined
    ) {
      pricesResponse.up !== undefined
        ? updatestoppriceUporDownTick("up", pricesResponse.up)
        : updatestoppriceUporDownTick("down", pricesResponse.down);
    }
  }

  const _handleKeyDownInput = (event: any) => {
    if (
      event.data &&
      (event.data.includes(".") ||
        event.data.includes(",") ||
        event.data.includes("-"))
    ) {
      event.preventDefault();
    }
  };

  const updateUporDownTick = (arrayType: any, newValues: any) => {
    setTicks((prevState: any) =>
      removeDuplicatesFromTheFetchingTicks(prevState, newValues, arrayType),
    );
  };

  const updatestoppriceUporDownTick = (arrayType: any, newValues: any) => {
    setstoppriceTicks((prevState: any) =>
      removeDuplicatesFromTheFetchingTicks(prevState, newValues, arrayType),
    );
  };

  const ticksIncrementorDecrement = (arr: any) => {
    const checkingKeysInObject = new Set();
    return arr?.filter((item: any) => {
      const key = item?.r;
      if (!checkingKeysInObject.has(key)) {
        checkingKeysInObject.add(key);
        return true;
      }
      return false;
    });
  };

  const removeDuplicatesFromTheFetchingTicks = (
    arr: any,
    newValues: any,
    arrayType: any,
  ) => {
    return {
      ...arr,
      [arrayType]: ticksIncrementorDecrement([...arr[arrayType], ...newValues]),
    };
  };

  useEffect(() => {
    if (openOrderViewModal) {
      PubSub.subscribe(
        pubsubEvents.socketKeys.CMED_ALL_CONTRACTS_SUCCESS,
        (msg, data) => {
          setpriceType(data.payload.FractionalPriceType);
          settickStrategy(data.payload.TickStrategy);
          tickGroupValidationFunction(data.payload.TickGroup);
          settickGroup(data.payload.TickGroup);
          setContractName(data.payload.Name);
          setContractLoading(false);
        },
      );

      PubSub.subscribe(
        pubsubEvents.socketKeys.CMED_PRICE_TICKS_RESPONSE,
        (msg, data) => {
          if (
            stopPriceRequestIds.current.length > 0 &&
            stopPriceRequestIds.current.find(
              (element) => element === data?.requestID,
            )
          ) {
            updatestoppriceTicks(data);
          } else if (
            priceRequestIds.current.length > 0 &&
            priceRequestIds.current.find(
              (element) => element === data?.requestID,
            )
          ) {
            updateTicks(data);
          } else {
            updatestoppriceTicks(data);
            updateTicks(data);
          }
        },
      );

      PubSub.subscribe(
        optionsGridConfig.socketKeys.CMED_ORDER_AMENDMENT,
        (msg, data: any) => {
          if (data?.status == "SUCCESS") {
            setOpenOrderViewModal(false);
          }
        },
      );
      if (tradingOrderDetailsData[0]) {
        _getTradeableitemInfo();
        if (!isOrderModified) {
          setselectedTif(
            getIdByDesc(tradingOrderDetailsData[0]?.ti?.split("-")[1]?.trim()),
          );
          setpriceValue(tradingOrderDetailsData[0]?.p2?.f);
          setstoppriceValue(tradingOrderDetailsData[0]?.sp?.f);
          setpriceValueRaw(tradingOrderDetailsData[0]?.p2?.r);
          setstoppriceValueRaw(tradingOrderDetailsData[0]?.sp?.r);
          setbasePriceValue(tradingOrderDetailsData[0]?.p2?.f);
          setbasestopPriceValue(tradingOrderDetailsData[0]?.sp?.f);
          setbasePriceValueRaw(tradingOrderDetailsData[0]?.p2?.r);
          setbasestopPriceValueRaw(tradingOrderDetailsData[0]?.sp?.r);
          setquantity(
            tradingOrderDetailsData[0]?.q?.r -
              tradingOrderDetailsData[0]?.fq?.r,
          );
          setDisclosedQuantity(tradingOrderDetailsData[0]?.dq?.r);
          setexpiryDate(
            tradingOrderDetailsData[0]?.e > refDate
              ? tradingOrderDetailsData[0]?.e
              : new Date().toISOString(),
          );
          setExpiryDateAPIFormatted(
            formatDate(
              tradingOrderDetailsData[0]?.e > refDate
                ? tradingOrderDetailsData[0]?.e
                : new Date().toISOString(),
              "API",
            ),
          );
          setSide(
            tradingOrderDetailsData[0]?.b.toLocaleLowerCase() === "buy"
              ? "bid"
              : "offer",
          );
          setNotes(tradingOrderDetailsData[0]?.on);
        }
        setIsAutomatedOrder(tradingOrderDetailsData[0]?.at);
      }
    }
  }, [tradingOrderDetailsData, openOrderViewModal]);

  function tickGroupValidationFunction(inputString: string) {
    const regex = /(-?[\d.]+)-([\d.]+)@/;
    const complexRegex = /[^@]*@[^@]*@[^@]*/;

    // Execute the regex on the input string
    const matches = inputString?.match(regex);
    const complexMatch = complexRegex.test(inputString);

    // Extract the values from the match array
    if (matches && !complexMatch) {
      const min = parseFloat(matches[1]); // Extract as float
      const max = parseFloat(matches[2]); // Extract as float
      settickGroupValidation({ min: min, max: max });
    } else {
      settickGroupValidation({ min: -1000000, max: 1000000 });
    }
  }

  useEffect(() => {
    if (openOrderViewModal && !isOrderModified) {
      let requestId;
      if (tradingOrderDetailsData[0] && priceType && tickStrategy) {
        requestId = uuidv4();
        priceRequestIds.current = [...priceRequestIds.current, requestId];
        fetchPriceTicks({
          basePrice: tradingOrderDetailsData[0]?.p2?.r,
          direction: ["up", "down"],
          requestId: requestId,
        });
      }

      if (
        tradingOrderDetailsData[0] &&
        priceType &&
        tickStrategy &&
        tradingOrderDetailsData[0]?.sp !== undefined &&
        tradingOrderDetailsData[0]?.sp?.f !== 0.0 &&
        (tradingOrderDetailsData[0]?.t === "Stop with Protection" ||
          tradingOrderDetailsData[0]?.t === "Stop-Limit")
      ) {
        requestId = uuidv4();
        stopPriceRequestIds.current = [
          ...stopPriceRequestIds.current,
          requestId,
        ];
        fetchPriceTicks({
          basePrice: tradingOrderDetailsData[0]?.sp?.r,
          direction: ["up", "down"],
          requestId: requestId,
        });
      }

      if (
        tradingOrderDetailsData[0] &&
        priceType &&
        tickStrategy &&
        tradingOrderDetailsData[0]?.t !== "Stop with Protection"
      ) {
        requestId = uuidv4();
        _updateGenericPriceInput(
          {
            target: {
              value: tradingOrderDetailsData[0]?.p2?.f,
            },
          },
          "price",
          true,
        );
      }

      if (
        tradingOrderDetailsData[0] &&
        priceType &&
        tickStrategy &&
        tradingOrderDetailsData[0]?.sp !== undefined &&
        tradingOrderDetailsData[0]?.sp?.f !== 0.0 &&
        (tradingOrderDetailsData[0]?.t === "Stop with Protection" ||
          tradingOrderDetailsData[0]?.t === "Stop-Limit")
      )
        _updateGenericPriceInput(
          {
            target: {
              value: tradingOrderDetailsData[0]?.sp?.f,
            },
          },
          "stopPrice",
          true,
        );
    }
  }, [priceType, tickStrategy, openOrderViewModal, tradingOrderDetailsData[0]]);

  function getIdByDesc(desc: string) {
    const tif = tifs?.find((tif) => tif.desc === desc);
    return tif ? tif.id : null;
  }

  function _updateQuantity(obj: any) {
    let updatedQuantity;
    if (obj.dir === "up") {
      updatedQuantity = quantity + obj.number;
    } else if (quantity > 0) {
      updatedQuantity = quantity - obj.number;
    }
    if (typeof updatedQuantity !== "undefined") {
      setquantity(updatedQuantity);
      if (
        updatedQuantity < QUANTITY_LIMITS.MIN ||
        updatedQuantity > QUANTITY_LIMITS.MAX
      ) {
        setQuantityErrorFlag(true);
        setQuantityErrorMsg(QuantityErrorConstants.ZERO_QUANTITY_ERROR);
      } else {
        setQuantityErrorFlag(false);
        setQuantityErrorMsg("");
      }
      if (tradingOrderDetailsData[0]?.dq?.r > 0) {
        validateDisclosedQuantity(disclosedQuantity, updatedQuantity);
      }
    }
    setIsOrderModified(true);
  }

  function _updateQuantityInput(event: any) {
    const val = +event.target.value.replace(/[^0-9]/g, "");
    event.target.value = val;
    setquantity(val);
    if (val < QUANTITY_LIMITS.MIN || val > QUANTITY_LIMITS.MAX) {
      setQuantityErrorFlag(true);
      setQuantityErrorMsg(QuantityErrorConstants.ZERO_QUANTITY_ERROR);
    } else {
      setQuantityErrorFlag(false);
      setQuantityErrorMsg("");
    }
    if (tradingOrderDetailsData[0]?.dq?.r > 0) {
      validateDisclosedQuantity(disclosedQuantity, val);
    }
    setIsOrderModified(true);
  }

  function _updateDisclosedQuantity(obj: any) {
    let updatedQuantity;
    if (obj.dir === "up") {
      updatedQuantity = disclosedQuantity + obj.number;
    } else if (disclosedQuantity > 0) {
      updatedQuantity = disclosedQuantity - obj.number;
    }
    if (typeof updatedQuantity !== "undefined") {
      setDisclosedQuantity(updatedQuantity);
      validateDisclosedQuantity(updatedQuantity, quantity);
    }
    setIsOrderModified(true);
  }

  function _updateDisclosedQuantityInput(event: any) {
    const disclosedQuantity = +event.target.value.replace(/[^0-9]/g, "");
    event.target.value = disclosedQuantity;
    setDisclosedQuantity(disclosedQuantity);
    validateDisclosedQuantity(disclosedQuantity, quantity);
    setIsOrderModified(true);
  }

  function _updateNotesInput(event: any) {
    setNotes(event?.target?.value);
    if (event?.target?.value?.length > 50) {
      setNotesErrorFlag(true);
    } else {
      setNotesErrorFlag(false);
    }
    setIsOrderModified(true);
  }

  function _handleDateChange(date: any) {
    setexpiryDate(date);
    setExpiryDateAPIFormatted(formatDate(date, "API"));
  }

  /**
   * Formats date for UI or API
   * accepts.
   * @param  {string} date selected date
   * @param  {string} date format format
   * @return {string}      converted date
   */
  function formatDate(date: any, format: any) {
    let chosenFormat = "API";
    if (format == "UI") {
      chosenFormat = config.dateFormats.dateFormatUI;
    }
    if (format == "API") {
      chosenFormat = config.dateFormats.dateFormatAPI;
    }
    if (format == "SHORT") {
      chosenFormat = config.dateFormats.dateFormatShort;
    }
    return moment(date).format(chosenFormat);
  }

  function _getTradeableitemInfo() {
    const TradeableItemId = tradingOrderDetailsData[0]?.ii;
    send(config.socket.channels.TRADING, {
      action: config.socket.actions.CMED_GET_CONTRACTS_BY_ITEM_ID,
      requestID: uuidv4(),
      type: "notUsedButMustBePresentForLegacyValidation",
      payload: {
        TradeableItemId,
      },
    });
  }

  const updatePriceDisplayAndFetchTicks = (
    price: string,
    priceRaw: number,
    basePrice: string | number,
    basePriceRaw: number,
    isError: boolean,
    errorMessage: string = "",
  ) => {
    const requestId = uuidv4();
    priceRequestIds.current = [...priceRequestIds.current, requestId];
    setpriceValue(price);
    setpriceValueRaw(priceRaw);
    setbasePriceValue(basePrice);
    setbasePriceValueRaw(basePriceRaw);
    setErrorFlag(isError);
    seterrorMsg(errorMessage);
    setPriceValueLoadingErrorState({ isLoading: false, error: false });
    fetchPriceTicks({
      basePrice: basePriceRaw,
      direction: ["up", "down"],
      requestId: requestId,
    });
    settickCounter(-1); // Common reset for tick counter
  };

  const count = (n: number | string): number => {
    if (Number.isInteger(n)) {
      return 0;
    }
    let numStr = String(n);
    // Check for scientific notation (e.g., "5e-7", "1.23e-4")
    const lowerNumStr = numStr.toLowerCase();
    if (lowerNumStr.includes("e-")) {
      const parts = lowerNumStr.split("e-");
      const coefficient = parts[0];
      const exponent = parseInt(parts[1], 10);

      let decimalPlaces = exponent;
      if (coefficient.includes(".")) {
        const coefficientDecimalPart = coefficient.split(".")[1];
        decimalPlaces += coefficientDecimalPart.length;
      }
      return decimalPlaces;
    }

    if (numStr.includes(".")) {
      return numStr.split(".")[1].length;
    }
    return 0;
  };
  const getNearestValidPrice = (price: string, tickStrategy: any) => {
    const sanitizedPrice = parseFloat(price.replace(/'/g, "."));
    const strategy = parseFloat(tickStrategy);
    const quotent = tickStrategy && sanitizedPrice / strategy;
    const roundedQuotient = quotent && Math.round(quotent);
    return (
      tickStrategy &&
      roundedQuotient &&
      (roundedQuotient * strategy).toFixed(count(strategy))
    );
  };

  function onKeyUpPressHandler(e: any, priceUpdateType: "price" | "stopPrice") {
    const isStopPrice = priceUpdateType === "stopPrice";
    const isCabinetString = /^C\d+$/i.test(priceValue);

    if (e.key === "Backspace" && isCabinetString) {
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            "",
            0,
            0,
            0,
            true,
            PriceErrorConstants.EMPTY_PRICE_ERROR,
          )
        : updatePriceDisplayAndFetchTicks(
            "",
            0,
            0,
            0,
            true,
            PriceErrorConstants.EMPTY_PRICE_ERROR,
          );
      e.preventDefault();
    }
  }

  function _updateGenericPriceInput(
    event: any,
    priceUpdateType: "price" | "stopPrice",
    firstLoad?: boolean,
  ) {
    !firstLoad && setIsOrderModified(true);
    const isStopPrice = priceUpdateType === "stopPrice";
    const inputValue =
      event?.target?.value.toString().replaceAll(",", "") || "";
    const currentPriceString =
      priceType !== "NotFractional"
        ? inputValue.toString().replace(/\./g, "'")
        : inputValue.toString();

    if (!tickGroup || tickGroup === "") return;

    const { decimal_number: decimalPrice, valid: isFractionalFormatValid } =
      FractionalToDecimalConverter(currentPriceString, priceType);
    const tickGroupInfo = parseTickGroupString(decimalPrice, tickGroup);
    const min = tickGroupInfo.minimumValue
      ? tickGroupInfo.minimumValue
      : -1000000;
    const max = tickGroupInfo.maximumValue
      ? tickGroupInfo.maximumValue
      : 1000000;
    const isPriceAdheringToTickSize = validatePrice(
      decimalPrice,
      tickGroupInfo.tickSize,
      priceType,
    );
    const isZeroAllowed = min < 0 && 0 < max;
    isStopPrice
      ? setStopPriceMinMaxErrorFlag(false)
      : setPriceMinMaxErrorFlag(false);
    if (isStopPrice) {
      setstopPriceErrorMsgFlag(false);
      setstopPriceErrorMsg(undefined);
    } else {
      setErrorFlag(false);
      seterrorMsg(undefined);
      setPriceValueLoadingErrorState({ isLoading: false, error: false });
    }
    const isCabinetString = /^C\d+$/i.test(priceValue);
    const isEffectivelyZero =
      currentPriceString?.toString().replace(/[.'-]/g, "") == 0;
    const isEmptyOrWhitespace =
      [undefined, null, ""].includes(currentPriceString) ||
      currentPriceString.trim() === "";
    const isOnlyDelimiter =
      currentPriceString === "'" ||
      currentPriceString === "." ||
      currentPriceString === "-";
    if (isEmptyOrWhitespace) {
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            PriceErrorConstants.EMPTY_PRICE_ERROR,
          )
        : updatePriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            PriceErrorConstants.EMPTY_PRICE_ERROR,
          );
      if (isStopPrice) {
        setstopPriceValidationErrorMsg("");
        setstopValidationPriceErrorMsgFlag(false);
      }
    } else if (isCabinetString) {
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            priceValue,
            priceValueRaw,
            priceValue,
            priceValueRaw,
            false,
            "",
          )
        : updatePriceDisplayAndFetchTicks(
            priceValue,
            priceValueRaw,
            priceValue,
            priceValueRaw,
            false,
            "",
          );
    } else if (isOnlyDelimiter) {
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            PriceErrorConstants.INVALID_PRICE_ERROR,
          )
        : updatePriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            PriceErrorConstants.INVALID_PRICE_ERROR,
          );
    } else if (isEffectivelyZero) {
      let outOfRangeMsg;
      if (!isZeroAllowed) {
        outOfRangeMsg = tickGroupInfo.cabinetError
          ? PriceErrorConstants.ZERO_AND_CABINET_ERROR
          : PriceErrorConstants.ZERO_PRICE_ERROR;
        isStopPrice
          ? updateStopPriceDisplayAndFetchTicks(
              currentPriceString,
              0,
              0,
              0,
              true,
              outOfRangeMsg,
            )
          : updatePriceDisplayAndFetchTicks(
              currentPriceString,
              0,
              0,
              0,
              true,
              outOfRangeMsg,
            );
      } else {
        isStopPrice
          ? updateStopPriceDisplayAndFetchTicks(
              currentPriceString,
              0,
              0,
              0,
              false,
              "",
            )
          : updatePriceDisplayAndFetchTicks(
              currentPriceString,
              0,
              0,
              0,
              false,
              "",
            );
      }
    } else if (firstLoad) {
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            tradingOrderDetailsData[0]?.sp?.f,
            tradingOrderDetailsData[0]?.sp?.r,
            tradingOrderDetailsData[0]?.sp?.f,
            tradingOrderDetailsData[0]?.sp?.r,
            false,
            "",
          )
        : updatePriceDisplayAndFetchTicks(
            tradingOrderDetailsData[0]?.p2?.f,
            tradingOrderDetailsData[0]?.p2?.r,
            tradingOrderDetailsData[0]?.p2?.f,
            tradingOrderDetailsData[0]?.p2?.r,
            false,
            "",
          );
    } else if (decimalPrice > max || decimalPrice < min) {
      const outOfRangeMsg = tickGroupInfo.cabinetError
        ? PriceErrorConstants.TICK_UP_TO_CABINET_PRICES_ERROR
        : `Price has to be between ${min.toString().includes("e") ? min.toFixed(Number(min.toString().split("-")[1])) : DecimalToFractionalConverter(min, priceType)} and ${max}.`;
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            outOfRangeMsg,
          )
        : updatePriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            outOfRangeMsg,
          );
      isStopPrice
        ? setStopPriceMinMaxErrorFlag(true)
        : setPriceMinMaxErrorFlag(true);
    } else if (tickGroupInfo.tickSize === null) {
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            PriceErrorConstants.INVALID_PRICE_ERROR,
          )
        : updatePriceDisplayAndFetchTicks(
            currentPriceString,
            0,
            0,
            0,
            true,
            PriceErrorConstants.INVALID_PRICE_ERROR,
          );
    } else if (!isPriceAdheringToTickSize || !isFractionalFormatValid) {
      let finalValRaw = parseFloat(
        getNearestValidPrice(decimalPrice.toString(), tickGroupInfo.tickSize),
      );
      finalValRaw === 0 ? (finalValRaw = 0) : (finalValRaw = finalValRaw); // this is to handle -0, which is a valid Number is js
      const errorMessage =
        priceType === "NotFractional"
          ? PriceErrorConstants.TICK_SIZE + tickStrategy
          : ". Price has to be of Type: " + priceType;
      const finalValueFractional =
        priceType !== "NotFractional"
          ? DecimalToFractionalConverter(finalValRaw, priceType)
          : finalValRaw.toFixed(count(tickGroupInfo.tickSize));

      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            currentPriceString,
            finalValRaw,
            finalValueFractional,
            finalValRaw,
            true,
            errorMessage,
          )
        : updatePriceDisplayAndFetchTicks(
            currentPriceString,
            finalValRaw,
            finalValueFractional,
            finalValRaw,
            true,
            errorMessage,
          );
    } else {
      // Valid price
      isStopPrice
        ? updateStopPriceDisplayAndFetchTicks(
            currentPriceString,
            decimalPrice,
            currentPriceString,
            decimalPrice,
            false,
            "",
          )
        : updatePriceDisplayAndFetchTicks(
            currentPriceString,
            decimalPrice,
            currentPriceString,
            decimalPrice,
            false,
            "",
          );
      if (tradingOrderDetailsData[0]?.t !== "Stop with Protection")
        _stopPriceValidation(decimalPrice, priceValueRaw);
    }
  }

  function _beforePriceInput(e: any) {
    const inputElement = e.target as HTMLInputElement;
    const { selectionStart, selectionEnd, value: currentValue } = inputElement;
    const insertedData =
      priceType !== "NotFractional"
        ? e.data.replace(".", "'") || ""
        : e.data.replace("", "") || ""; // e.data can be null (e.g., for deletion)
    let potentialValueAfterOperation = currentValue;
    if (selectionStart !== null && selectionEnd !== null) {
      potentialValueAfterOperation =
        currentValue.substring(0, selectionStart) +
        insertedData +
        currentValue.substring(selectionEnd);
    }
    // Allow deletion that results in an empty string to proceed; _updatePriceInput will handle empty validation.
    if (potentialValueAfterOperation.trim() === "" && insertedData === "") {
      return;
    }
    const parsedPriceString = potentialValueAfterOperation
      ?.toString()
      .replaceAll(",", "");
    const tickGroupInfo1 = parseTickGroupString(
      parseFloat(parsedPriceString),
      tickGroup,
    );
    let decimalPlaces;
    tickGroupInfo1.tickSize !== null && priceType === "NotFractional"
      ? (decimalPlaces = count(tickGroupInfo1.tickSize.toString()))
      : tickStrategy !== undefined
        ? (decimalPlaces = count(tickStrategy))
        : (decimalPlaces = 0);
    const isInputFormatValidByRegex = PriceRegexValidator(
      potentialValueAfterOperation,
      priceType,
      decimalPlaces,
    );
    if (!isInputFormatValidByRegex) {
      e.preventDefault();
    }
  }

  const updateStopPriceDisplayAndFetchTicks = (
    stopPrice: string | undefined,
    stopPriceRaw: number,
    baseStopPriceValue: string | number,
    baseStopPriceValueRaw: number,
    isError: boolean,
    errorMessage: string = "",
  ) => {
    const requestId = uuidv4();
    stopPriceRequestIds.current = [...stopPriceRequestIds.current, requestId];
    stopPrice && setstoppriceValue(stopPrice);
    setstoppriceValueRaw(stopPriceRaw);
    setbasestopPriceValue(baseStopPriceValue);
    setbasestopPriceValueRaw(baseStopPriceValueRaw);
    setstopPriceErrorMsgFlag(isError);
    setstopPriceErrorMsg(errorMessage);
    fetchPriceTicks({
      basePrice: baseStopPriceValueRaw,
      direction: ["up", "down"],
      requestId: requestId,
    });
    setstoptickCounter(-1); // Common reset for tick counter
    setPriceValueLoadingErrorState({
      isLoading: false,
      error: false,
    });
  };

  const isStartDateBlock = (dateString: string) => {
    const date = new Date(dateString).toISOString();
    const endDate = new Date(
      parseInt(allFutureDates.getTime()?.toString()),
    ).toISOString();
    if (date < endDate) return true;
    else return false;
  };

  function fetchPriceTicks(options: any) {
    send(config.socket.channels.TRADING, {
      action: config.socket.actions.CMED_ITEM_PRICES,
      requestID: options.requestId,
      type: "cmedGetPriceTicksRequest",
      payload: {
        itemId: tradingOrderDetailsData[0]?.ii, // a valid value taken from ITradingGridGroupItemMarketData.ii
        basePrice: options?.basePrice, // Decimal? or does it need to be fractional sometimes? b.f or bo.f
        direction: options?.direction, // true=Up, false=Down
      },
    });
  }

  function _tickHandler(
    obj: { dir: "up" | "down" },
    priceContext: "limitOrder" | "stopOrder",
  ) {
    const isStopOrderContext = priceContext === "stopOrder";
    setIsOrderModified(true);
    // Determine which set of state variables and setters to use
    const currentPriceValue = isStopOrderContext ? stoppriceValue : priceValue;
    const setCurrentPriceValue = isStopOrderContext
      ? setstoppriceValue
      : setpriceValue;
    const currentPriceValueRaw = isStopOrderContext
      ? stoppriceValueRaw
      : priceValueRaw;
    const setCurrentPriceValueRaw = isStopOrderContext
      ? setstoppriceValueRaw
      : setpriceValueRaw;
    const currentBasePriceValue = isStopOrderContext
      ? basestopPriceValue
      : basePriceValue;
    const currentBasePriceValueRaw = isStopOrderContext
      ? basestopPriceValueRaw
      : basePriceValueRaw;
    const currentTickCounter = isStopOrderContext
      ? stoptickCounter
      : tickCounter;
    const setCurrentTickCounter = isStopOrderContext
      ? setstoptickCounter
      : settickCounter;
    const pricesSource = isStopOrderContext ? stoppriceticks : ticks;
    const currentPriceRequestIdsRef = isStopOrderContext
      ? stopPriceRequestIds
      : priceRequestIds;
    const minMaxErrorFlag = isStopOrderContext
      ? stopPriceMinMaxErrorFlag
      : priceMinMaxErrorFlag;
    const setMinMaxErrorFlag = isStopOrderContext
      ? setStopPriceMinMaxErrorFlag
      : setPriceMinMaxErrorFlag;

    let dirConditional;
    const priceList = pricesSource[obj.dir],
      priceListLength = priceList.length - 1;

    if (
      currentPriceValueRaw !== undefined &&
      currentBasePriceValueRaw !== undefined
    ) {
      dirConditional =
        obj.dir === "up"
          ? currentPriceValueRaw >= currentBasePriceValueRaw
          : currentPriceValueRaw <= currentBasePriceValueRaw;
    } else {
      // Raw price or base raw price is undefined, cannot determine dirConditional
      return;
    }

    const oppositeDir = obj.dir === "up" ? "down" : "up";
    let nextPriceCandidate;
    let newTickCounter;

    if (dirConditional) {
      newTickCounter = currentTickCounter + 1;
      if (
        newTickCounter === priceListLength &&
        priceList[priceListLength]?.r !== undefined
      ) {
        const requestId = uuidv4();
        currentPriceRequestIdsRef.current = [
          ...currentPriceRequestIdsRef.current,
          requestId,
        ];
        fetchPriceTicks({
          basePrice: priceList[priceListLength].r,
          direction: [obj.dir],
          requestId: requestId,
        });
      }
      nextPriceCandidate =
        newTickCounter === -1
          ? "default"
          : pricesSource[obj.dir][newTickCounter];
    } else {
      newTickCounter = currentTickCounter - 1;
      nextPriceCandidate =
        newTickCounter === -1
          ? "default"
          : pricesSource[oppositeDir][newTickCounter];
    }

    const isEffectivelyZeroNPC =
      nextPriceCandidate?.f?.toString().replace(/[.'-]/g, "") == 0;
    const isEffectivelyZeroPriceCandidate =
      currentPriceValue?.toString().replace(/[.'-]/g, "") == "0";
    if (isEffectivelyZeroNPC && isEffectivelyZeroPriceCandidate) {
      return;
    }

    // If the next potential price is the same as the current price, do nothing.
    if (
      nextPriceCandidate &&
      nextPriceCandidate !== "default" &&
      nextPriceCandidate.f === currentPriceValue
    ) {
      return;
    }
    // Trying to tick to base, but already at base.
    if (
      nextPriceCandidate === "default" &&
      currentPriceValueRaw === currentBasePriceValueRaw
    ) {
      return;
    }

    if (minMaxErrorFlag) {
      if (
        obj.dir === "down" &&
        tradingOrderDetailsData[0]?.s2.includes("Options")
      ) {
        setCurrentTickCounter(-1);
      } else {
        setCurrentTickCounter(newTickCounter);
      }
      setMinMaxErrorFlag(false);
    } else {
      setCurrentTickCounter(newTickCounter);
    }

    const finalPriceToSet = nextPriceCandidate;

    if (finalPriceToSet && finalPriceToSet === "default") {
      setCurrentPriceValue(currentBasePriceValue);
      setCurrentPriceValueRaw(currentBasePriceValueRaw);

      const isEffectivelyZero =
        currentBasePriceValueRaw?.toString().replace(/[.'-]/g, "") == 0;
      const tickGroupInfo = parseTickGroupString(
        currentBasePriceValue,
        tickGroup,
      );
      const min = tickGroupInfo.minimumValue
        ? tickGroupInfo.minimumValue
        : -1000000;
      const max = tickGroupInfo.maximumValue
        ? tickGroupInfo.maximumValue
        : 1000000;
      const isZeroAllowed = min < 0 && 0 < max;

      if (isStopOrderContext) {
        if (isEffectivelyZero && !isZeroAllowed) {
          let outOfRangeMsg = tickGroupInfo.cabinetError
            ? PriceErrorConstants.ZERO_AND_CABINET_ERROR
            : PriceErrorConstants.ZERO_PRICE_ERROR;
          setstopPriceErrorMsgFlag(true);
          setstopPriceErrorMsg(outOfRangeMsg);
        } else {
          setstopPriceErrorMsgFlag(false);
          setstopPriceErrorMsg("");
        }
      } else {
        // limitOrder context
        if (isEffectivelyZero && !isZeroAllowed) {
          let outOfRangeMsg = tickGroupInfo.cabinetError
            ? PriceErrorConstants.ZERO_AND_CABINET_ERROR
            : PriceErrorConstants.ZERO_PRICE_ERROR;
          setErrorFlag(true);
          seterrorMsg(outOfRangeMsg);
        } else {
          setErrorFlag(false);
          seterrorMsg("");
          setPriceValueLoadingErrorState({ isLoading: false, error: false });
        }
      }
    } else if (finalPriceToSet) {
      const isEffectivelyZero =
        finalPriceToSet?.r?.toString().replace(/[.'-]/g, "") == 0;
      const tickGroupInfo = parseTickGroupString(finalPriceToSet?.r, tickGroup);
      const min = tickGroupInfo.minimumValue
        ? tickGroupInfo.minimumValue
        : -1000000;
      const max = tickGroupInfo.maximumValue
        ? tickGroupInfo.maximumValue
        : 1000000;
      const isZeroAllowed = min < 0 && 0 < max;

      setCurrentPriceValue(finalPriceToSet?.f);
      setCurrentPriceValueRaw(finalPriceToSet?.r);

      if (isStopOrderContext) {
        if (isEffectivelyZero && !isZeroAllowed) {
          let outOfRangeMsg = tickGroupInfo.cabinetError
            ? PriceErrorConstants.ZERO_AND_CABINET_ERROR
            : PriceErrorConstants.ZERO_PRICE_ERROR;
          setstopPriceErrorMsgFlag(true);
          setstopPriceErrorMsg(outOfRangeMsg);
        } else {
          setstopPriceErrorMsgFlag(false);
          setstopPriceErrorMsg("");
        }
      } else {
        // limitOrder context
        if (isEffectivelyZero && !isZeroAllowed) {
          let outOfRangeMsg = tickGroupInfo.cabinetError
            ? PriceErrorConstants.ZERO_AND_CABINET_ERROR
            : PriceErrorConstants.ZERO_PRICE_ERROR;
          setErrorFlag(true);
          seterrorMsg(outOfRangeMsg);
        } else {
          setErrorFlag(false);
          seterrorMsg("");
          setPriceValueLoadingErrorState({ isLoading: false, error: false });
        }
      }

      if (
        (tradingOrderDetailsData[0]?.t === "Stop with Protection" ||
          tradingOrderDetailsData[0]?.t === "Stop-Limit") &&
        errorFlag
      ) {
        updateStopPriceDisplayAndFetchTicks(
          finalPriceToSet?.f,
          finalPriceToSet?.r,
          finalPriceToSet?.f,
          finalPriceToSet?.r,
          false,
          "",
        );
      }

      // if (side === "bid") {
      //   if ((tradingOrderDetailsData[0]?.t == "Stop with Protection" || tradingOrderDetailsData[0]?.t == "Stop-Limit") && finalPriceToSet?.r < basestopPriceValueRaw) {
      //     updateStopPriceDisplayAndFetchTicks(finalPriceToSet?.f, finalPriceToSet?.r, finalPriceToSet?.f, finalPriceToSet?.r, false, "")
      //   }
      // } else {
      //   if ((tradingOrderDetailsData[0]?.t == "Stop with Protection" || tradingOrderDetailsData[0]?.t == "Stop-Limit") && finalPriceToSet?.r > basestopPriceValueRaw) {
      //     updateStopPriceDisplayAndFetchTicks(finalPriceToSet?.f, finalPriceToSet?.r, finalPriceToSet?.f, finalPriceToSet?.r, false, "")
      //   }
      // }
    }
  }

  const statusGetter = (orderStatus: number | undefined) => {
    switch (orderStatus) {
      case 0:
        return OrderStatus.HELD;
      case 1:
        return OrderStatus.WORKING;
      case 2:
        return OrderStatus.PARTIAL_FILLED;
      case 3:
        return OrderStatus.PARTIAL_FILLED_HELD;
      case 4:
        return OrderStatus.PARTIAL_FILLED_CANCELLED;
      case 5:
        return OrderStatus.FILLED;
      case 6:
        return OrderStatus.CANCELLED;
      case 7:
        return OrderStatus.PENDING;
      case 8:
        return OrderStatus.PENDING_HELD;
      default:
        return OrderStatus.HELD;
    }
  };

  const statusColorGetter = (orderStatus: number | undefined) => {
    switch (orderStatus) {
      case 0:
      case 3:
      case 8:
        return "medium";
      case 1:
      case 2:
        return "warning";
      case 7:
        return "dark";
      case 4:
      case 5:
        return "success";
      case 6:
        return "danger";
      default:
        return "medium";
    }
  };

  const createTickActionPayload = (direction: any, type: any, id: any) => ({
    action: `cmed/selectedorder/tick${direction}`,
    requestID: uuidv4(),
    type,
    payload: {
      orderId: id,
    },
  });

  const createOrderActionPayload = (action: any, id: any) => ({
    action: `cmed/selectedorder/${action}`,
    requestID: uuidv4(),
    type: `${action}SelectedOrderRequest`,
    payload: {
      orderId: id,
    },
  });

  const createOrderActionForActivateOrderPayload = (action: any, id: any) => ({
    action: `cmed/selectedorder/${action}`,
    requestID: uuidv4(),
    type: `${action}SelectedOrderRequest`,
    payload: {
      orderId: id,
      ignorePriceWarnings: "false",
    },
  });

  const killOrderHandler = () => {
    startMetric(MetricConstants.ORDER_KILL_LATENCY, MetricTypeConstants.TIMER);
    send(
      config.socket.channels.TRADING,
      createOrderActionPayload("cancel", orderId),
    );
    CMEDfirebaseLogEvent(
      firebaseEventConfig.CMEDComponentNames.CMED_ORDER_BOOK,
      firebaseEventConfig.eventNames.CMED_ORDER_BOOK.CMED_ORDER_BOOK_KILL_ORDER,
    );
  };
  const holdOrderHandler = () => {
    startMetric(MetricConstants.ORDER_HOLD_LATENCY, MetricTypeConstants.TIMER);
    send(
      config.socket.channels.TRADING,
      createOrderActionPayload("hold", orderId),
    );
    CMEDfirebaseLogEvent(
      firebaseEventConfig.CMEDComponentNames.CMED_ORDER_BOOK,
      firebaseEventConfig.eventNames.CMED_ORDER_BOOK.CMED_ORDER_BOOK_HOLD_ORDER,
    );
  };

  const activateOrderHandler = () => {
    startMetric(
      MetricConstants.ORDER_ACTIVATE_LATENCY,
      MetricTypeConstants.TIMER,
    );
    send(
      config.socket.channels.TRADING,
      createOrderActionForActivateOrderPayload("activate", orderId),
    );
    CMEDfirebaseLogEvent(
      firebaseEventConfig.CMEDComponentNames.CMED_ORDER_BOOK,
      firebaseEventConfig.eventNames.CMED_ORDER_BOOK
        .CMED_ORDER_BOOK_ACTIVE_ORDER,
    );
  };

  function submitOrderAmendRequest() {
    startMetric(
      MetricConstants.ORDER_MODIFY_LATENCY,
      MetricTypeConstants.TIMER,
    );
    hapticsImpactHeavy();
    send(config.socket.channels.TRADING, {
      action: config.socket.actions.CMED_ORDER_AMEND,
      requestID: uuidv4(),
      type: "cmedOrderAmendRequest",
      payload: {
        orderId: parseInt(orderId),
        orderPrice: priceValueRaw,
        orderQuantity: quantity + tradingOrderDetailsData[0]?.fq?.r,
        tif: parseInt(selectedTif),
        stopPrice:
          tradingOrderDetailsData[0]?.t === "Stop-Limit" ||
          tradingOrderDetailsData[0]?.t === "Stop with Protection"
            ? stoppriceValueRaw
            : 0,
        expiryDate:
          selectedTif === "4" && !isEmpty(expiryDate)
            ? expiryDateAPIFormatted
            : null,
        disclosedQuantity: disclosedQuantity,
        notes: notes ? notes : "",
      },
    });
    switch (side) {
      case "bid":
        CMEDfirebaseLogEvent(
          firebaseEventConfig.CMEDComponentNames.CMED_ORDER_BOOK,
          firebaseEventConfig.eventNames.CMED_ORDER_BOOK
            .CMED_ORDER_BOOK_MODIFY_BID_ORDER,
        );
        break;
      case "offer":
        CMEDfirebaseLogEvent(
          firebaseEventConfig.CMEDComponentNames.CMED_ORDER_BOOK,
          firebaseEventConfig.eventNames.CMED_ORDER_BOOK
            .CMED_ORDER_BOOK_MODIFY_OFFER_ORDER,
        );
        break;
      default:
        break;
    }
    setIsOrderModified(true);
  }

  const getResForParticularOrderDetails = (msg: any, response: any) => {
    const { data, subscriptionKind, isSnapshot, identifier } = response.payload;
    if (identifier === orderId) {
      switch (subscriptionKind) {
        case "TradingOrderDetails":
          if (isSnapshot) {
            setTradingOrderDetailsData(data);
            setOrderLoading(false);
          } else {
            setTradingOrderDetailsData((prevData: any) => {
              return prevData[0]?.id === data[0]?.id ? data : prevData;
            });
          }
          break;
        case "TradingOrderFills":
          if (isSnapshot) {
            setTradingOrderFillsData({ data: data, identifier: identifier });
            setFillsDataLoading(false);
          } else {
            setTradingOrderFillsData((prevState) => {
              if (identifier === prevState.identifier) {
                let TOFdata: any[] = [];
                let arrofIds: any[] = [];
                prevState.data.forEach((e: { id: any }) => {
                  arrofIds.push(e.id);
                });
                if (arrofIds.includes(data[0]?.id)) {
                  TOFdata = prevState.data.map(
                    (obj: any) =>
                      data.find((o: { id: any }) => o.id === obj.id) || obj,
                  );
                } else {
                  TOFdata = [...data, ...prevState.data];
                }
                return { data: TOFdata, identifier: prevState.identifier };
              }
              return prevState;
            });
          }
          break;
        case "TradingOrderBidOffers":
          if (isSnapshot) {
            setTradingOrderBidOffersData({
              data: data,
              identifier: identifier,
            });
            setMarketDataLoading(false);
          } else {
            setTradingOrderBidOffersData((prevState) => {
              if (identifier === prevState.identifier) {
                let TOBOdata: any[] = [];
                let arrofIds: any[] = [];
                prevState.data.forEach((e: { id: any }) => {
                  arrofIds.push(e.id);
                });
                if (arrofIds.includes(data[0]?.id)) {
                  TOBOdata = prevState.data.map(
                    (obj: any) =>
                      data.find((o: { id: any }) => o.id === obj.id) || obj,
                  );
                } else {
                  TOBOdata = [...data, ...prevState.data];
                }
                return { data: TOBOdata, identifier: prevState.identifier };
              }
              return prevState;
            });
          }
          break;
        default:
          break;
      }
    }
  };

  let subRequestForTradingOrderDetails = {
    action: config.socket.actions.CMED_ORDERS_SUBSCRIBE,
    type: OrdersType.ORDERS_DATA_SUBSCRIBE,
    requestID: uuidv4(),
    payload: {
      orderId: orderId,
      ordersDataType: OrdersDataType.TRADING_ORDER_DETAILS,
    },
  };

  let unSubRequestForTradingOrderDetails = {
    action: config.socket.actions.CMED_ORDERS_UNSUBSCRIBE,
    type: OrdersType.ORDERS_DATA_UNSUBSCRIBE,
    requestID: uuidv4(),
    payload: {
      orderId: orderId,
      ordersDataType: OrdersDataType.TRADING_ORDER_DETAILS,
    },
  };

  useEffect(() => {
    if (openOrderViewModal) {
      //TradingOrderDetails
      PubSub.subscribe(
        pubsubEvents.stompSubscriptionKeys.CMED_ORDER_DETAILS_UPDATE,
        getResForParticularOrderDetails,
      );

      //TradingOrderFills
      PubSub.subscribe(
        pubsubEvents.stompSubscriptionKeys.CMED_ORDER_FILLS_UPDATE,
        getResForParticularOrderDetails,
      );

      //TradingOrderBidOffers
      PubSub.subscribe(
        pubsubEvents.stompSubscriptionKeys.CMED_ORDER_BID_OFFERS_UPDATE,
        getResForParticularOrderDetails,
      );
      send(config.socket.channels.TRADING, subRequestForTradingOrderDetails);
      setCapacitorPreference(
        CapacitorPreferencesConstants.ORDERBOOK_MODAL_ORDERID,
        orderId,
      );
    }
  }, [openOrderViewModal]);

  const selectedTIFRef = useRef<HTMLIonSelectElement>(null);

  const handleOpenTIF = () => {
    if (selectedTIFRef?.current) {
      selectedTIFRef?.current?.open();
      hapticsImpactMedium();
    }
  };

  return (
    <React.Fragment>
      <IonModal
        isOpen={openOrderViewModal}
        onDidDismiss={() => {
          setOpenOrderViewModal(false);
          setOrderId("");
          closeOrderViewModal();
          settickCounter(-1);
          setstoptickCounter(-1);
          setselectedTif(tifs?.[0]?.id);
          setquantity(QUANTITY_LIMITS.MIN);
          settickStrategy(undefined);
          setpriceType(undefined);
          setpriceValue("");
          setpriceValueRaw(undefined);
          setbasePriceValue(undefined);
          setbasePriceValueRaw(undefined);
          setstoppriceValue("");
          setstoppriceValueRaw(undefined);
          setbasestopPriceValue(undefined);
          setbasestopPriceValueRaw(undefined);
          setstopPriceErrorMsg("");
          setstopPriceErrorMsgFlag(false);
          setErrorFlag(false);
          setDisclosedQuantity(QUANTITY_LIMITS.MIN);
          seterrorMsg("");
          setPriceValueLoadingErrorState({
            isLoading: true,
            error: false,
          });
          setTicks({ up: [], down: [] });
          priceRequestIds.current = [];
          stopPriceRequestIds.current = [];
          setstoppriceTicks({ up: [], down: [] });
          setTradingOrderDetailsData([]);
          setTradingOrderBidOffersData({ data: [], identifier: "" });
          setTradingOrderFillsData({ data: [], identifier: "" });
          setNotes("");
          setNotesErrorFlag(false);
          setQuantityErrorFlag(false);
          setQuantityErrorMsg("");
          setDisclosedQuantityErrorFlag(false);
          setDisclosedQuantityErrorMsg("");
          setIsAutomatedOrder(false);
          setIsOrderModified(false);
          send(
            config.socket.channels.TRADING,
            unSubRequestForTradingOrderDetails,
          );
          removeCapacitorPreference("OrderBookViewModalOpen_orderId");
          setContractName("");
          setCurrentSegment("orderTicket");
          setContractLoading(true);
        }}
      >
        <IonHeader className="ion-no-border">
          <IonToolbar>
            <IonTitle>
              <p className="ion-no-margin text-bold">ORDER DETAILS</p>
            </IonTitle>
            <IonButtons slot="end">
              <IonButton
                onClick={() => {
                  setOpenOrderViewModal(false);
                  hapticsImpactMedium();
                }}
              >
                <IonIcon
                  icon={closeOutline}
                  color="dark"
                  slot="icon-only"
                ></IonIcon>
              </IonButton>
            </IonButtons>
          </IonToolbar>
          <IonSegment
            value={currentSegment}
            onIonChange={(e: any) => {
              setCurrentSegment(e.detail.value);
              hapticsImpactMedium();
            }}
            className={
              orderLoading ||
              marketDataLoading ||
              fillsDataLoading ||
              contractLoading
                ? "ion-hide"
                : ""
            }
          >
            <IonSegmentButton value="orderTicket">
              <IonLabel>Order Ticket</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton value="Fills">
              <IonLabel>Fills</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </IonHeader>
        {orderLoading ||
        marketDataLoading ||
        fillsDataLoading ||
        contractLoading ? (
          <Skeleton_OrderViewModal />
        ) : (
          <Fragment>
            <IonContent>
              {currentSegment === "orderTicket" ? (
                <main
                  style={{
                    marginLeft: "13px",
                    marginRight: "13px",
                    marginTop: "18px",
                    marginBottom: "10px",
                  }}
                  className="orderTicket_container"
                >
                  <section
                    style={{
                      display: "flex",
                      gap: 10,
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          wordBreak: "break-all",
                          marginBottom: "5px",
                        }}
                      >
                        <p
                          className="ion-no-margin text-bold"
                          style={{ fontSize: "var(--one-font-size-16)" }}
                        >
                          {getModifiedContractNameFromOrder(
                            contractName,
                            tradingOrderDetailsData,
                          )}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 7,
                          marginBottom: "20px",
                        }}
                      >
                        <p
                          className="ion-no-margin text-bold"
                          style={{ fontSize: "var(--one-font-size-10)" }}
                        >
                          {`${tradingOrderDetailsData[0]?.p} ${tradingOrderDetailsData[0]?.d}`}
                        </p>
                        <div
                          className={`ob__side_sub-section ${side === "bid" ? `ob__side_type_buy` : `ob__side_type_sell`}`}
                        >
                          {side === "bid" ? "B" : "S"}
                        </div>
                      </div>
                    </div>
                    <div>
                      <IonBadge
                        color={statusColorGetter(tradingOrderDetailsData[0]?.s)}
                      >
                        {statusGetter(tradingOrderDetailsData[0]?.s)}
                      </IonBadge>
                    </div>
                  </section>
                  <section
                    style={{ marginBottom: "20px" }}
                    className="marketDatatableComponent"
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 2 }}
                    >
                      {tableHeaders1.map((elem: string, id: number) => (
                        <div
                          key={id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "10px",
                            backgroundColor: "#112B4A",
                            width: "25%",
                            justifyContent:
                              id === 1 || id === 3 ? "flex-end" : "flex-start",
                          }}
                        >
                          <p
                            className="ion-no-margin text-bold"
                            style={{ fontSize: "var(--one-font-size-7)" }}
                          >
                            {elem}
                          </p>
                        </div>
                      ))}
                    </div>
                    {tradingOrderBidOffersData?.data?.length > 0 && (
                      <div style={{ display: "flex" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "10px",
                            width: "25%",
                          }}
                        >
                          <p
                            className="ion-no-margin"
                            style={{ fontSize: "var(--one-font-size-7)" }}
                          >
                            {tradingOrderBidOffersData?.data[0]?.bq?.f}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "10px",
                            width: "25%",
                            justifyContent: "flex-end",
                          }}
                        >
                          <p
                            className="ion-no-margin"
                            style={{ fontSize: "var(--one-font-size-7)" }}
                          >
                            {tradingOrderBidOffersData?.data[0]?.b?.f}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "10px",
                            width: "25%",
                          }}
                        >
                          <p
                            className="ion-no-margin"
                            style={{ fontSize: "var(--one-font-size-7)" }}
                          >
                            {tradingOrderBidOffersData?.data[0]?.o?.f}
                          </p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "10px",
                            width: "25%",
                            justifyContent: "flex-end",
                          }}
                        >
                          <p
                            className="ion-no-margin"
                            style={{ fontSize: "var(--one-font-size-7)" }}
                          >
                            {tradingOrderBidOffersData?.data[0]?.oq?.f}
                          </p>
                        </div>
                      </div>
                    )}
                  </section>
                  <section
                    className="price-working-qty-section"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div className="price-section" style={{ width: "50%" }}>
                      <p
                        className="ion-no-margin text-bold"
                        style={{
                          fontSize: "var(--one-font-size-6)",
                          marginBottom: "10px",
                        }}
                      >
                        PRICE
                      </p>
                      <TickComponent
                        errorFlag={errorFlag}
                        handleChange={(e: any) =>
                          _updateGenericPriceInput(e, "price")
                        }
                        handleClick={debounce(
                          (obj: any) => _tickHandler(obj, "limitOrder"),
                          50,
                        )}
                        name={"Price"}
                        value={priceValue}
                        tickDisabled={
                          statusGetter(tradingOrderDetailsData[0]?.s) ===
                            "Filled" ||
                          statusGetter(tradingOrderDetailsData[0]?.s) ===
                            "Cancelled" ||
                          statusGetter(tradingOrderDetailsData[0]?.s) ===
                            "Partially Filled & Cancelled" ||
                          tradingOrderDetailsData[0]?.t ===
                            "Stop with Protection"
                        }
                        priceDisabled={
                          tradingOrderDetailsData[0]?.t ===
                          "Stop with Protection"
                        }
                        readOnly={
                          statusGetter(tradingOrderDetailsData[0]?.s) ===
                            "Filled" ||
                          statusGetter(tradingOrderDetailsData[0]?.s) ===
                            "Cancelled" ||
                          statusGetter(tradingOrderDetailsData[0]?.s) ===
                            "Partially Filled & Cancelled"
                        }
                        onBeforeInput={_beforePriceInput}
                        onKeyUpPressFunc={(e: any) =>
                          onKeyUpPressHandler(e, "price")
                        }
                        onFocusOut={(e: any) =>
                          formatPriceForScreen(
                            e,
                            "price",
                            priceType,
                            setpriceValue,
                            setstoppriceValue,
                          )
                        }
                        onFocus={(e: any) =>
                          removeCommasOnFocus(
                            e,
                            "price",
                            setpriceValue,
                            setstoppriceValue,
                            priceType,
                          )
                        }
                      />
                    </div>
                    <div className="qty-section" style={{ width: "50%" }}>
                      <p
                        className="ion-no-margin text-bold"
                        style={{
                          fontSize: "var(--one-font-size-6)",
                          marginBottom: "10px",
                        }}
                      >
                        WORKING QUANTITY
                      </p>
                      {statusGetter(tradingOrderDetailsData[0]?.s) !==
                        "Filled" &&
                      statusGetter(tradingOrderDetailsData[0]?.s) !==
                        "Cancelled" &&
                      statusGetter(tradingOrderDetailsData[0]?.s) !==
                        "Partially Filled & Cancelled" ? (
                        <TickComponent
                          handleClick={_updateQuantity}
                          handleChange={_updateQuantityInput}
                          name={"Working Qty"}
                          value={quantity}
                          errorFlag={quantityErrorFlag}
                          onBeforeInput={(event: any) =>
                            _handleKeyDownInput(event)
                          }
                        />
                      ) : (
                        <EmptyTickComponent />
                      )}
                    </div>
                  </section>
                  <div style={{ display: "flex", width: "100%", gap: "20px" }}>
                    <div style={{ width: "50%" }} role="alert">
                      {errorFlag && (
                        <IonText color={"danger"}>
                          <p
                            className="ion-no-margin"
                            style={{
                              fontSize: "var(--one-font-size-8)",
                              marginTop: "5px",
                            }}
                          >
                            {errorMsg}
                          </p>
                        </IonText>
                      )}
                    </div>
                    <div style={{ width: "50%" }} role="alert">
                      {quantityErrorFlag && (
                        <IonText color={"danger"}>
                          <p
                            className="ion-no-margin"
                            style={{
                              fontSize: "var(--one-font-size-8)",
                              marginTop: "5px",
                            }}
                          >
                            {quantityErrorMsg}
                          </p>
                        </IonText>
                      )}
                    </div>
                  </div>
                  <section
                    className="display-qty-toggle-section"
                    style={{
                      marginTop: "20px",
                      marginBottom: "20px",
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                  >
                    <div className="toggle-section" style={{ width: "50%" }}>
                      <p
                        className="ion-no-margin text-bold"
                        style={{
                          fontSize: "var(--one-font-size-6)",
                          marginBottom: "10px",
                        }}
                      >
                        DISPLAY QUANTITY
                      </p>
                      <div
                        style={{
                          display: "flex",
                          gap: 13,
                          alignItems: "center",
                        }}
                      >
                        <IonToggle
                          checked={tradingOrderDetailsData[0]?.dq?.r > 0}
                          mode="md"
                          disabled
                        ></IonToggle>
                        <p
                          className="ion-no-margin text-bold"
                          style={{ fontSize: "var(--one-font-size-6)" }}
                        >
                          {tradingOrderDetailsData[0]?.dq?.r > 0
                            ? "TURN OFF"
                            : "TURN ON"}
                        </p>
                      </div>
                    </div>
                    <div
                      className="display-qty-section"
                      style={{ width: "50%" }}
                    >
                      {tradingOrderDetailsData[0]?.dq?.r > 0 ? (
                        <TickComponent
                          handleClick={_updateDisclosedQuantity}
                          handleChange={_updateDisclosedQuantityInput}
                          name={"Display Qty"}
                          value={disclosedQuantity}
                          errorFlag={disclosedQuantityErrorFlag}
                          tickDisabled={
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Filled" ||
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Cancelled" ||
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Partially Filled & Cancelled"
                          }
                          readOnly={
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Filled" ||
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Cancelled" ||
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Partially Filled & Cancelled"
                          }
                          onBeforeInput={(event: any) =>
                            _handleKeyDownInput(event)
                          }
                        />
                      ) : (
                        <EmptyTickComponent />
                      )}
                    </div>
                  </section>
                  <div style={{ display: "flex", width: "100%", gap: "20px" }}>
                    <div style={{ width: "50%" }}></div>
                    <div style={{ width: "50%" }} role="alert">
                      {disclosedQuantityErrorFlag && (
                        <IonText color={"danger"}>
                          <p
                            className="ion-no-margin"
                            style={{
                              fontSize: "var(--one-font-size-8)",
                              marginTop: "5px",
                              position: "relative",
                              top: "-20px",
                            }}
                          >
                            {disclosedQuantityErrorMsg}
                          </p>
                        </IonText>
                      )}
                    </div>
                  </div>
                  <section
                    className="ordertype-stopprice-section"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      width: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <div className="ordertype-section" style={{ width: "50%" }}>
                      <p
                        className="ion-no-margin text-bold"
                        style={{
                          fontSize: "var(--one-font-size-6)",
                          marginBottom: "10px",
                        }}
                      >
                        ORDER TYPE
                      </p>
                      <div
                        style={{
                          display: "flex",
                          height: "41px",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          padding: "12px 16px",
                          backgroundColor: "rgba(255, 255, 255, 0.05)",
                          border: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        <div
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: "vertical",
                            wordBreak: "break-all",
                          }}
                        >
                          <p
                            className="ion-no-margin"
                            style={{
                              fontSize: "var(--one-font-size-10)",
                            }}
                          >
                            {tradingOrderDetailsData[0]?.t?.replace(
                              /with/gi,
                              "w/",
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="stopprice-section" style={{ width: "50%" }}>
                      <p
                        className="ion-no-margin text-bold"
                        style={{
                          fontSize: "var(--one-font-size-6)",
                          marginBottom: "10px",
                        }}
                      >
                        STOP PRICE
                      </p>
                      {tradingOrderDetailsData[0]?.sp !== undefined &&
                      tradingOrderDetailsData[0]?.sp?.f !== 0.0 &&
                      (tradingOrderDetailsData[0]?.t ===
                        "Stop with Protection" ||
                        tradingOrderDetailsData[0]?.t === "Stop-Limit") ? (
                        <TickComponent
                          errorFlag={stopPriceErrorMsgFlag}
                          handleChange={(e) =>
                            _updateGenericPriceInput(e, "stopPrice")
                          }
                          handleClick={debounce(
                            (obj: any) => _tickHandler(obj, "stopOrder"),
                            50,
                          )}
                          onBeforeInput={_beforePriceInput}
                          name={"Stop Price"}
                          value={stoppriceValue}
                          onFocusOut={(e: any) =>
                            formatPriceForScreen(
                              e,
                              "stopPrice",
                              priceType,
                              setpriceValue,
                              setstoppriceValue,
                            )
                          }
                          onFocus={(e: any) =>
                            removeCommasOnFocus(
                              e,
                              "stopPrice",
                              setpriceValue,
                              setstoppriceValue,
                              priceType,
                            )
                          }
                          tickDisabled={
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Filled" ||
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Cancelled" ||
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Partially Filled & Cancelled"
                          }
                          readOnly={
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Filled" ||
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Cancelled" ||
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Partially Filled & Cancelled"
                          }
                          onKeyUpPressFunc={(e: any) =>
                            onKeyUpPressHandler(e, "stopPrice")
                          }
                        />
                      ) : (
                        <EmptyTickComponent />
                      )}
                    </div>
                  </section>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                    role="alert"
                  >
                    <div style={{ width: "50%" }}></div>
                    <div style={{ width: "50%" }}>
                      {stopPriceErrorMsgFlag && (
                        <IonText color={"danger"}>
                          <p
                            className="ion-no-margin"
                            style={{
                              fontSize: "var(--one-font-size-8)",
                              marginTop: "5px",
                            }}
                          >
                            {stopPriceErrorMsg}
                          </p>
                        </IonText>
                      )}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                    }}
                    role="alert"
                  >
                    <div style={{ width: "50%" }}></div>
                    <div style={{ width: "50%" }}>
                      {stopPriceValidationErrorMsgFlag && !errorFlag && (
                        <IonText color={"danger"}>
                          <p
                            className="ion-no-margin"
                            style={{
                              fontSize: "var(--one-font-size-8)",
                              marginTop: "5px",
                            }}
                          >
                            {stopPriceValidationErrorMsg}
                          </p>
                        </IonText>
                      )}
                    </div>
                  </div>
                  <section
                    className="tif-date-section"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      width: "100%",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    <div className="tif-section" style={{ width: "50%" }}>
                      <p
                        className="ion-no-margin text-bold"
                        style={{
                          fontSize: "var(--one-font-size-6)",
                          marginBottom: "10px",
                        }}
                      >
                        TIME IN FORCE
                      </p>
                      {statusGetter(tradingOrderDetailsData[0]?.s) !==
                        "Filled" &&
                      statusGetter(tradingOrderDetailsData[0]?.s) !==
                        "Cancelled" &&
                      statusGetter(tradingOrderDetailsData[0]?.s) !==
                        "Pending" &&
                      !(
                        statusGetter(tradingOrderDetailsData[0]?.s) ===
                          "Working" && isAutomatedOrder
                      ) && //user shouldn't be allowed to change the TIF for working contingent/automated orders
                      statusGetter(tradingOrderDetailsData[0]?.s) !==
                        "Pending & Held" &&
                      statusGetter(tradingOrderDetailsData[0]?.s) !==
                        "Partially Filled & Cancelled" ? (
                        <div
                          onClick={
                            tifs?.length === 0 ? undefined : handleOpenTIF
                          }
                          style={{
                            display: "flex",
                            height: "41px",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            padding: "12px 16px",
                            backgroundColor: "rgba(255, 255, 255, 0.05)",
                            border: "1px solid rgba(255, 255, 255, 0.10)",
                            ...(tifs?.length === 0 && {
                              opacity: 0.5,
                              pointerEvents: "none",
                            }),
                          }}
                        >
                          <div
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: "vertical",
                              wordBreak: "break-all",
                            }}
                          >
                            <p
                              className="ion-no-margin"
                              style={{
                                fontSize: "var(--one-font-size-10)",
                              }}
                            >
                              {tifs?.length === 0
                                ? "No Data"
                                : tifs?.find(
                                    (obj: any) => obj?.id === selectedTif,
                                  )?.desc || selectedTif}
                            </p>
                          </div>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <IonIcon
                              icon={expandIcon}
                              style={{ height: "20px", width: "20px" }}
                            />
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            height: "41px",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                            padding: "12px 16px",
                            backgroundColor: "rgba(255, 255, 255, 0.05)",
                            border: "1px solid rgba(255, 255, 255, 0.10)",
                            ...(tifs?.length === 0 && {
                              opacity: 0.5,
                              pointerEvents: "none",
                            }),
                          }}
                        >
                          <div
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 1,
                              WebkitBoxOrient: "vertical",
                              wordBreak: "break-all",
                            }}
                          >
                            <p
                              className="ion-no-margin"
                              style={{
                                fontSize: "var(--one-font-size-10)",
                              }}
                            >
                              {tradingOrderDetailsData[0]?.ti
                                ?.split("-")[1]
                                ?.trim()}
                            </p>
                          </div>
                        </div>
                      )}
                      <IonSelect
                        interface="action-sheet"
                        value={selectedTif}
                        onIonChange={(e: any) => {
                          setselectedTif(e.detail.value);
                          setIsOrderModified(true);
                          hapticsImpactMedium();
                        }}
                        ref={selectedTIFRef}
                        className="ion-hide"
                      >
                        {tifs?.map((tif: any) => {
                          return (
                            <IonSelectOption value={tif?.id}>
                              {tif?.desc}
                            </IonSelectOption>
                          );
                        })}
                      </IonSelect>
                    </div>
                    <div className="tifdate-section" style={{ width: "50%" }}>
                      <p
                        className="ion-no-margin text-bold"
                        style={{
                          fontSize: "var(--one-font-size-6)",
                          marginBottom: "10px",
                        }}
                      >
                        DATE
                      </p>
                      {selectedTif === "4" && tradingOrderDetailsData[0]?.e ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            height: "41px",
                            background: "rgba(255, 255, 255, 0.05)",
                            border: "1px solid rgba(255, 255, 255, 0.10)",
                            padding: "12px 16px",
                          }}
                        >
                          {statusGetter(tradingOrderDetailsData[0]?.s) !==
                            "Filled" &&
                          statusGetter(tradingOrderDetailsData[0]?.s) !==
                            "Cancelled" &&
                          statusGetter(tradingOrderDetailsData[0]?.s) !==
                            "Partially Filled & Cancelled" ? (
                            <IonDatetimeButton
                              datetime="tif_date_modal"
                              onClick={() => hapticsImpactMedium()}
                            ></IonDatetimeButton>
                          ) : (
                            <>
                              {new Date(
                                tradingOrderDetailsData[0]?.e,
                              )?.getDate()}{" "}
                              {new Date(tradingOrderDetailsData[0]?.e)
                                ?.toLocaleString("en-US", { month: "long" })
                                .split("", 3)}{" "}
                              {new Date(
                                tradingOrderDetailsData[0]?.e,
                              )?.getFullYear()}
                            </>
                          )}
                          <IonModal keepContentsMounted={true}>
                            <IonDatetime
                              id="tif_date_modal"
                              presentation="date"
                              showDefaultButtons={true}
                              value={expiryDate}
                              min={`${today.toISOString()}`}
                              max={`${allFutureDates.toISOString()}`}
                              isDateEnabled={isStartDateBlock}
                              onIonChange={(e: any) => {
                                _handleDateChange(e.detail.value);
                                setIsOrderModified(true);
                                hapticsImpactMedium();
                              }}
                            ></IonDatetime>
                          </IonModal>
                        </div>
                      ) : (
                        <EmptyDateComponent />
                      )}
                    </div>
                  </section>
                  <section
                    className="account-section"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "20px",
                      width: "100%",
                      justifyContent: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <div
                      className="ordertype-section"
                      style={{ width: "100%" }}
                    >
                      <p
                        className="ion-no-margin text-bold"
                        style={{
                          fontSize: "var(--one-font-size-6)",
                          marginBottom: "10px",
                        }}
                      >
                        ACCOUNT
                      </p>
                      <div
                        style={{
                          display: "flex",
                          height: "41px",
                          alignItems: "center",
                          justifyContent: "space-between",
                          width: "100%",
                          padding: "12px 16px",
                          backgroundColor: "rgba(255, 255, 255, 0.05)",
                          border: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        <div
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: "vertical",
                            wordBreak: "break-all",
                          }}
                        >
                          <p
                            className="ion-no-margin"
                            style={{
                              fontSize: "var(--one-font-size-10)",
                            }}
                          >
                            {tradingOrderDetailsData[0]?.a}
                          </p>
                        </div>
                      </div>
                    </div>
                  </section>
                  {userCMEDEntitlements?.showNotes && (
                    <Fragment>
                      <section
                        className="notes-section"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                          width: "100%",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          className="notes-section"
                          style={{ width: "100%" }}
                        >
                          <p
                            className="ion-no-margin text-bold"
                            style={{
                              fontSize: "var(--one-font-size-6)",
                              marginBottom: "10px",
                            }}
                          >
                            NOTES
                          </p>
                          <div
                            style={{
                              display: "flex",
                              height: "41px",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                              padding: "12px 16px",
                              border: "1px solid rgba(255, 255, 255, 0.10)",
                              backgroundColor: notesErrorFlag
                                ? "rgba(232, 61, 61, 0.086)"
                                : "rgba(255, 255, 255, 0.05)",
                            }}
                          >
                            <IonInput
                              placeholder={
                                statusGetter(tradingOrderDetailsData[0]?.s) ===
                                  "Filled" ||
                                statusGetter(tradingOrderDetailsData[0]?.s) ===
                                  "Cancelled" ||
                                statusGetter(tradingOrderDetailsData[0]?.s) ===
                                  "Partially Filled & Cancelled"
                                  ? ""
                                  : "Add notes here"
                              }
                              type="text"
                              inputmode="text"
                              value={notes}
                              onIonInput={(e: any) => {
                                _updateNotesInput(e);
                                setIsOrderModified(true);
                              }}
                              readonly={
                                statusGetter(tradingOrderDetailsData[0]?.s) ===
                                  "Filled" ||
                                statusGetter(tradingOrderDetailsData[0]?.s) ===
                                  "Cancelled" ||
                                statusGetter(tradingOrderDetailsData[0]?.s) ===
                                  "Partially Filled & Cancelled"
                              }
                            ></IonInput>
                          </div>
                        </div>
                      </section>
                      <div style={{ width: "100%" }} role="alert">
                        {notesErrorFlag && (
                          <IonText color={"danger"}>
                            <p
                              className="ion-no-margin"
                              style={{
                                fontSize: "var(--one-font-size-8)",
                                marginTop: "5px",
                              }}
                            >
                              Maximum notes limit is upto 50 characters
                            </p>
                          </IonText>
                        )}
                      </div>
                    </Fragment>
                  )}
                </main>
              ) : (
                <main
                  style={{
                    marginLeft: "13px",
                    marginRight: "13px",
                    marginTop: "18px",
                    marginBottom: "10px",
                  }}
                  className="fills_container"
                >
                  <section
                    style={{
                      display: "flex",
                      gap: 10,
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          wordBreak: "break-all",
                          marginBottom: "5px",
                        }}
                      >
                        <p
                          className="ion-no-margin text-bold"
                          style={{ fontSize: "var(--one-font-size-16)" }}
                        >
                          {getModifiedContractNameFromOrder(
                            contractName,
                            tradingOrderDetailsData,
                          )}
                        </p>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 7,
                          marginBottom: "15px",
                        }}
                      >
                        <p
                          className="ion-no-margin text-bold"
                          style={{ fontSize: "var(--one-font-size-10)" }}
                        >
                          {`${tradingOrderDetailsData[0]?.p} ${tradingOrderDetailsData[0]?.d}`}
                        </p>
                        <div
                          className={`ob__side_sub-section ${side === "bid" ? `ob__side_type_buy` : `ob__side_type_sell`}`}
                        >
                          {side === "bid" ? "B" : "S"}
                        </div>
                      </div>
                    </div>
                  </section>
                  <section
                    style={{ marginBottom: "20px" }}
                    className="AverageTradePriceComponent"
                  >
                    <div
                      style={{
                        width: "100%",
                        padding: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#112B4A",
                        fontSize: "var(--one-font-size-8)",
                        gap: 4,
                      }}
                    >
                      <p
                        className="ion-no-margin text-bold"
                        style={{ display: "inline" }}
                      >
                        AVG PRICE:
                      </p>
                      <p
                        className="ion-no-margin text-bold"
                        style={{ display: "inline" }}
                      >
                        {`${tradingOrderDetailsData[0]?.atp?.f}`}
                      </p>
                    </div>
                  </section>
                  <section
                    style={{ marginBottom: "20px" }}
                    className="fillsDatatableComponent"
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 2 }}
                    >
                      {tableHeaders2.map((elem: string, id: number) => (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "10px",
                            backgroundColor: "#112B4A",
                            width: "calc(100%/3)",
                          }}
                        >
                          <p
                            className="ion-no-margin text-bold"
                            style={{ fontSize: "var(--one-font-size-7)" }}
                          >
                            {elem}
                          </p>
                        </div>
                      ))}
                    </div>
                    {tradingOrderFillsData?.data?.length > 0 ? (
                      tradingOrderFillsData?.data?.map((elem, index) => (
                        <div key={index} style={{ display: "flex" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "10px",
                              width: "calc(100%/3)",
                            }}
                          >
                            <p
                              className="ion-no-margin"
                              style={{ fontSize: "var(--one-font-size-7)" }}
                            >
                              {new Date(elem?.t).toLocaleString()}
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "10px",
                              width: "calc(100%/3)",
                            }}
                          >
                            <p
                              className="ion-no-margin"
                              style={{ fontSize: "var(--one-font-size-8)" }}
                            >
                              {elem?.q?.f}
                            </p>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "10px",
                              width: "calc(100%/3)",
                            }}
                          >
                            <p
                              className="ion-no-margin"
                              style={{ fontSize: "var(--one-font-size-7)" }}
                            >
                              {elem?.p?.f}
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div
                        role="alert"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <IonText color={"medium"}>
                          <p
                            className="ion-no-margin"
                            style={{
                              fontSize: "var(--one-font-size-8)",
                              marginTop: "10px",
                            }}
                          >
                            No Data Available
                          </p>
                        </IonText>
                      </div>
                    )}
                  </section>
                </main>
              )}
            </IonContent>
            <IonFooter
              className="ion-no-padding ion-no-border"
              style={{ marginBottom: "20px" }}
            >
              <IonGrid className="ion-padding">
                <IonRow>
                  <IonCol size="12">
                    {statusGetter(tradingOrderDetailsData[0]?.s) !== "Filled" &&
                      statusGetter(tradingOrderDetailsData[0]?.s) !==
                        "Cancelled" &&
                      statusGetter(tradingOrderDetailsData[0]?.s) !==
                        "Partially Filled & Cancelled" && (
                        <IonButton
                          className="custom_cmed_mobile_button"
                          onClick={() => {
                            hapticsImpactHeavy();
                            if (userCMEDEntitlements?.warnWhenModifyingOrder) {
                              if (
                                (tradingOrderDetailsData[0]?.sp !== undefined &&
                                  tradingOrderDetailsData[0]?.sp?.f !== 0.0 &&
                                  (tradingOrderDetailsData[0]?.t ===
                                    "Stop with Protection" ||
                                    tradingOrderDetailsData[0]?.t ===
                                      "Stop-Limit") &&
                                  stopPriceErrorMsgFlag) ||
                                errorFlag ||
                                notesErrorFlag ||
                                quantityErrorFlag ||
                                disclosedQuantityErrorFlag
                              ) {
                                return;
                              }
                              setIsModifyOrderAlertOpen(true);
                            } else {
                              submitOrderAmendRequest();
                            }
                          }}
                          disabled={
                            priceValueLoadingErrorState?.isLoading ||
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Filled" ||
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Cancelled" ||
                            statusGetter(tradingOrderDetailsData[0]?.s) ===
                              "Partially Filled & Cancelled" ||
                            !isOrderModified
                          }
                          expand="block"
                          color={side === "bid" ? "primary" : "danger"}
                        >
                          MODIFY {side === "bid" ? "BID" : "OFFER"}
                        </IonButton>
                      )}
                  </IonCol>
                </IonRow>
                <IonRow>
                  <IonCol size="6">
                    {statusGetter(tradingOrderDetailsData[0]?.s) === "Held" ||
                    statusGetter(tradingOrderDetailsData[0]?.s) ===
                      "Partially Filled & Held" ||
                    statusGetter(tradingOrderDetailsData[0]?.s) ===
                      "Pending & Held" ? (
                      <IonButton
                        className="custom_cmed_mobile_button"
                        expand="block"
                        fill="outline"
                        color="success"
                        onClick={() => {
                          setIsActivateOrderAlertOpen(true);
                          hapticsImpactMedium();
                        }}
                      >
                        ACTIVATE ORDER
                      </IonButton>
                    ) : (
                      <IonButton
                        className="custom_cmed_mobile_button"
                        expand="block"
                        fill="outline"
                        color="dark"
                        onClick={() => {
                          setIsHoldOrderAlertOpen(true);
                          hapticsImpactMedium();
                        }}
                        disabled={
                          statusGetter(tradingOrderDetailsData[0]?.s) ===
                            "Filled" ||
                          statusGetter(tradingOrderDetailsData[0]?.s) ===
                            "Cancelled" ||
                          statusGetter(tradingOrderDetailsData[0]?.s) ===
                            "Partially Filled & Cancelled"
                        }
                      >
                        HOLD ORDER
                      </IonButton>
                    )}
                  </IonCol>
                  <IonCol size="6">
                    <IonButton
                      className="custom_cmed_mobile_button"
                      expand="block"
                      fill="outline"
                      color="danger"
                      onClick={() => {
                        setIsKillOrderAlertOpen(true);
                        hapticsImpactMedium();
                      }}
                      disabled={
                        statusGetter(tradingOrderDetailsData[0]?.s) ===
                          "Filled" ||
                        statusGetter(tradingOrderDetailsData[0]?.s) ===
                          "Cancelled" ||
                        statusGetter(tradingOrderDetailsData[0]?.s) ===
                          "Partially Filled & Cancelled"
                      }
                    >
                      KILL ORDER
                    </IonButton>
                  </IonCol>
                </IonRow>
              </IonGrid>
            </IonFooter>
          </Fragment>
        )}
      </IonModal>
      {/* hold order alert*/}
      <IonAlert
        className="one-alert"
        isOpen={isHoldOrderAlertOpen}
        header="Hold Order"
        message={`Are you sure you want to hold ${tradingOrderDetailsData[0]?.p} ${tradingOrderDetailsData[0]?.d}?`}
        onDidDismiss={() => setIsHoldOrderAlertOpen(false)}
        buttons={[
          {
            text: "No",
            cssClass: "alert-button-cancel",
          },
          {
            text: "Yes",
            cssClass: "alert-button-confirm",
            handler: () => {
              holdOrderHandler();
              setOpenOrderViewModal(false);
            },
          },
        ]}
      ></IonAlert>
      {/* kill order alert*/}
      <IonAlert
        className="one-alert"
        isOpen={isKillOrderAlertOpen}
        header="Kill Order"
        message={`Are you sure you want to kill ${tradingOrderDetailsData[0]?.p} ${tradingOrderDetailsData[0]?.d}?`}
        onDidDismiss={() => setIsKillOrderAlertOpen(false)}
        buttons={[
          {
            text: "No",
            cssClass: "alert-button-cancel",
          },
          {
            text: "Yes",
            cssClass: "alert-button-confirm",
            handler: () => {
              killOrderHandler();
              setOpenOrderViewModal(false);
            },
          },
        ]}
      ></IonAlert>
      {/* activate order alert*/}
      <IonAlert
        className="one-alert"
        isOpen={isActivateOrderAlertOpen}
        header="Activate Order"
        message={`Are you sure you want to activate ${tradingOrderDetailsData[0]?.p} ${tradingOrderDetailsData[0]?.d}?`}
        onDidDismiss={() => setIsActivateOrderAlertOpen(false)}
        buttons={[
          {
            text: "No",
            cssClass: "alert-button-cancel",
          },
          {
            text: "Yes",
            cssClass: "alert-button-confirm",
            handler: () => {
              activateOrderHandler();
              setOpenOrderViewModal(false);
            },
          },
        ]}
      ></IonAlert>
      {/* view order contract name alert*/}
      <IonAlert
        isOpen={isViewContractNameAlertOpen}
        header="Contract"
        message={`${tradingOrderDetailsData[0]?.p} ${tradingOrderDetailsData[0]?.d}`}
        onDidDismiss={() => setIsViewContractNameAlertOpen(false)}
        buttons={[
          {
            text: "Okay",
          },
        ]}
      ></IonAlert>
      {/* modify order alert*/}
      <IonAlert
        className="one-alert"
        isOpen={isModifyOrderAlertOpen}
        header={`Modify ${side === "bid" ? "bid" : "offer"}`}
        message={`Are you sure you want to modify ${
          side === "bid" ? "bid" : "offer"
        }?`}
        onDidDismiss={() => setIsModifyOrderAlertOpen(false)}
        buttons={[
          {
            text: "No",
            cssClass: "alert-button-cancel",
          },
          {
            text: "Yes",
            cssClass: "alert-button-confirm",
            handler: () => {
              submitOrderAmendRequest();
            },
          },
        ]}
      ></IonAlert>
    </React.Fragment>
  );
};

export default OrderViewModal;
